// src/app/core/interceptors/auth.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const token = storage.getItem(StorageService.ACCESS_TOKEN);

  // Precise skip check to avoid accidentally skipping protected routes like /api/owner/menu/
  // Public routes: /api/auth/* and /api/menu/* (public menu)
  const isPublicAuth = req.url.includes('/api/auth/login') || 
                       req.url.includes('/api/auth/register-cafe') || 
                       req.url.includes('/api/auth/refresh');
  const isPublicMenu = req.url.includes('/api/menu/') && !req.url.includes('/api/owner/');
  const isPublicStatus = req.url.includes('/health') || req.url.includes('/actuator');
  const isThirdParty = req.url.includes('openfoodfacts.org');

  if (isPublicAuth || isPublicMenu || isPublicStatus || isThirdParty) {
    console.log(`[AuthInterceptor] Skipping token for public route: ${req.url}`);
    return next(req);
  }

  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log(`[AuthInterceptor] Added token for: ${req.url}`);
    return next(cloned);
  }

  console.log(`[AuthInterceptor] No token for: ${req.url}`);
  return next(req);
};
